// src/pages/ErrorPage.tsx
import { useRouteError } from "react-router-dom";
import { Button, Container, Stack, Typography } from "@mui/material";
import { IconHome } from "@tabler/icons-react";

const ErrorPage = () => {
  const error = useRouteError();
  console.error("React Router Error:", error);

  return (
    <Container
      maxWidth="md"
      sx={{
        mt: 10,
        textAlign: "center",
        height: "80vh",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
      }}
    >
      <Stack spacing={4} alignItems="center">
        <Typography variant="h3" color="primary" fontWeight={700}>
          Algo deu errado!
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Encontramos um problema ao carregar esta página.
          <br /> Já estamos investigando, mas você pode tentar novamente ou
          voltar para a página inicial.
        </Typography>

        <Button
          variant="contained"
          startIcon={<IconHome />}
          onClick={() => (window.location.href = "/dashboard")}
        >
          Voltar para o início
        </Button>
      </Stack>
    </Container>
  );
};

export default ErrorPage;
